<div class="wrap">
    <div class="header">
      <div class="title">
        <fa-icon [icon]="faChevronLeft" (click)="goBack()"></fa-icon>
        <h1>{{nameCamera}}</h1>
      </div>
    </div>
  
    <div class="content">
      <div class="infos_config">
        <div class="infos">
          <div class="loading" *ngIf="updateFormLoading">
            <mat-spinner [color]="color" [diameter]="50"></mat-spinner>
          </div>
          <form [formGroup]="updateCameraForm" #addCamera (ngSubmit)="onSubmit()">
            <div class='title_form'>
              <h3>Infos</h3>
              <button type="submit" [ngClass]="{isInactive: inactive, isActive: !inactive }"
                [disabled]="inactive">Modifier</button>
            </div>
            <mat-form-field appearance="outline">
              <mat-label>{{'updateCamera.name.label' | translate}}</mat-label>
              <input matInput formControlName="name" class="input_form_updateCameraForm" Form _form
                (input)="isInactive($event.target.value); getTitlePage($event.target.value)">
              <mat-error>{{'updateCamera.name.erromMessage' | translate}}
              </mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>{{'updateCamera.ip.label' | translate}}</mat-label>
              <input matInput formControlName="ip" class="input_form_updateCameraForm"
                (input)="isInactive($event.target.value)">
              <mat-error>{{'updateCamera.ip.erromMessage' | translate}}
              </mat-error>
            </mat-form-field>
            <div class="port_and_syncTime">
              <mat-form-field appearance="outline">
                <mat-label>{{'updateCamera.port.label' | translate}}</mat-label>
                <input matInput formControlName="port" id="port" class="input_form_updateCameraForm"
                  (input)="isInactive($event.target.value)">
                <mat-error>
                  {{'updateCamera.port.erromMessage.pattern' | translate}}
                </mat-error>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>{{'updateCamera.syncTime.label' | translate}}</mat-label>
                <input matInput formControlName="syncTime" type="number" min="1" id="syncTime"
                  class="input_form_updateCameraForm" (input)="isInactive($event.target.value)">
                <mat-error>
                  {{'updateCamera.syncTime.erromMessage.pattern' | translate}}
                </mat-error>
              </mat-form-field>
            </div>
  
          </form>
        </div>
        <div class=" config">
          <h3>Configuration</h3>
          <div class="mode">
            <mat-slide-toggle labelPosition="before" [color]="color" [(ngModel)]="cameraMode"
              (change)="updateConfigCamera()">Démo</mat-slide-toggle>
            <p>Production</p>
          </div>
          <div class="mode">
            <mat-slide-toggle labelPosition="before" id="test" [color]="color" [(ngModel)]="cameraReset"
              (change)="updateConfigCamera()">Reset
            </mat-slide-toggle>
          </div>
          <mat-form-field appearance="outline" class="time">
            <mat-label>Temps limite de stationnement</mat-label>
            <input matInput formControlName="timeExceeded" type="time" value="01:30" class="input_form_updateCameraForm"
              (input)="isInactive($event.target.value)">
            <!-- <mat-error>
              {{'updateCamera.syncTime.erromMessage.pattern' | translate}}
            </mat-error> -->
          </mat-form-field>
        </div>
      </div>
      <div class="slots">
        <div class="slots_title">
          <h3>Slots</h3>
          <div class="edit_and_search">
            <!-- <div class="edit" (click)="opDialogAddSlot()" (mouseenter)="showElement()" (mouseleave)="show = false">
              <fa-icon [icon]="faSyncAlt" class="faSyncAlt"></fa-icon>
              <div class="show_after_hover" *ngIf="show">
                <fa-icon [icon]="faSyncAlt"></fa-icon>
                <span>Initialiser les places de parking</span>
              </div>
            </div> -->
            <div class="search_bar">
              <input type="text" placeholder="Chercher une place de parking ..."
                (input)="applyFilter($event.target.value)">
  
              <!-- <fa-icon [icon]=" faTimes" (click)="resetSearch($event)"></fa-icon> -->
  
              <fa-icon [icon]=" faSearch"></fa-icon>
            </div>
          </div>
        </div>
  
        <app-smartparking-slots-table></app-smartparking-slots-table>
  
      </div>
    </div>
  
  </div>